var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"sub-navigation"},_vm._l((_vm.links),function(link,index){return _c('li',{key:index,staticClass:"sub-navigation__item",class:{'sub-navigation__item--selected': link.selected}},[_c('a',{staticClass:"sub-navigation__link",attrs:{"href":link.href,"title":link.text}},[_vm._v(_vm._s(link.text))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }